import { render, staticRenderFns } from "./manage-deposit-pf.vue?vue&type=template&id=4214a226"
import script from "./manage-deposit-pf.vue?vue&type=script&lang=js"
export * from "./manage-deposit-pf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports